// some logs for investigation purpose, to be removed by 29/07/2025
/* eslint-disable guard-for-in */
export function stringifyEvent(object: Event, depth = 0, maxDepth = 2) {
	// go through max 2 levels of circular references
	if (depth > maxDepth) return 'Object';

	const obj = {};
	for (const key in object) {
		// @ts-expect-error - TS7053
		let value = object[key];
		// @ts-expect-error - TS2339
		if (value instanceof Node) value = { id: value.id };
		else if (value instanceof Window) value = 'Window';
		else if (value instanceof Object) value = stringifyEvent(value, depth + 1, maxDepth);
		// @ts-expect-error - TS7053
		obj[key] = value;
	}

	return depth ? obj : JSON.stringify(obj);
}
